import { dataOpsInitialState } from './initial-state';

export const dataOpsResetReducer = () => dataOpsInitialState;
